import styled from '@emotion/styled';

export const Main = styled.main`
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  display: flex;
  width: 100%;
`;